export const permissionGroupLabels = {
    dashboard: "Dashboard",
    support: "Suporte",
    infrastructure: "Infraestrutura",
    register: "Cadastro",
    reports: "Relatórios",
    external_access: "Acesso externo",
    requests: "Solicitações",
    integrations: "Integrações",
    after_sales: "Pós-venda",
    activity_control: "Controle de atividades",
    curriculum_vitae: "Gestão de candidatos"
};

export const permissionsList = [
    {name: "Projetos", key: "dashboard_projects", group: "dashboard"},
    {name: "Visualizar histórico de licenças", key: "licenses_history", dependsOn: ["dashboard_projects"], group: "dashboard"},
    {name: "Licenciamento", key: "dashboard_license", group: "dashboard"},
    {name: "Spider", key: "dashboard_spider", group: "dashboard"},
    {name: "Câmeras de OCR", key: "noc", group: "dashboard"},

    {name: "Atendimentos", key: "control_attend", group: "support"},
    {name: "Atualizações", key: "support_release", group: "support"},
    {name: "Atualizações 2", key: "support_release2", group: "support"},
    {name: "Versões", key: "see_versions", group: "support"},
    {name: "Cadastrar/Editar versões", key: "edit_versions", dependsOn: ["see_versions"], group: "support"},

    {name: "Atendimentos", key: "attendances", group: "infrastructure"},
    {name: "Alterar status", key: "alter_status", dependsOn: ["attendances"], group: "infrastructure"},
    {name: "Encerrar atendimentos", key: "supervisor", dependsOn: ["attendances"], group: "infrastructure"},
    {name: "Apenas visualizar atendimentos do projeto ou revenda do usuário", key: "see_attendances", dependsOn: ["attendances"], group: "infrastructure"},
    {name: "Ordens de Serviço", key: "orders", group: "infrastructure"},

    {name: "Projetos (Cidades)", key: "cities", group: "register"},
    {name: 'Editar "Equipamentos"', key: "credential", dependsOn: ["cities"], group: "register"},
    {name: "Excluir projetos", key: "exclude_projects", dependsOn: ["cities"], group: "register"},
    {name: "Ativar/desativar clone", key: "change_clone", dependsOn: ["cities"], group: "register"},
    {name: "Licenças - Smartcapture", key: "licenses", dependsOn: ["cities"], group: "register"},
    {name: "Produtos", key: "products", group: "register"},
    {name: "Revendas", key: "resales", group: "register"},
    {name: "Usuário/Cliente", key: "user_system", group: "register"},
    {name: 'Editar grupo SSH', key: "can_edit_ssh", dependsOn: ["user_system"], group: "register"},
    {name: 'Editar permissões', key: "can_edit_permissions", dependsOn: ["user_system"], group: "register"},
    {name: 'Editar dados dos usuários revenda Sentry', key: "can_edit_sentry_resale", dependsOn: ["user_system"], group: "register"},
    {name: "Templates", key: "support", group: "register"},
    {name: "Técnicos", key: "technician", group: "register"},

    {name: "Suporte - Atendimentos", key: "reports_software_attendances", group: "reports"},
    {name: "Infraestrutura - Atendimentos", key: "reports_hardware_attendances", group: "reports"},
    {name: "Infraestrutura - Tempo de atendimentos", key: "reports_hardware_attendances_time", group: "reports"},
    {name: "Ações", key: "reports_actions", group: "reports"},
    {name: "Noc", key: "reports_noc", group: "reports"},
    {name: "Itens", key: "reports_items", group: "reports"},
    {name: "OS por projeto", key: "reports_os_project", group: "reports"},
    {name: "OS por produto", key: "reports_os_product", group: "reports"},
    {name: "Serviços prestados", key: "reports_services_provided", group: "reports"},

    {name: "Permitir acesso via internet", key: "public_access", group: "external_access"},
    {name: "Cadastro de atendimentos", key: "user_project", dependsOn: ["public_access"], group: "external_access"},

    {name: "Todos usuários", key: "request", group: "requests"},
    {name: "Somente meu usuário", key: "request_only_my_user", group: "requests"},

    {name: "Integrações", key: "integrations", group: "integrations"},

    {name: "Atendimentos", key: "after_sales_attendances", group: "after_sales"},
    {name: "Treinamentos", key: "after_sales_trainings", group: "after_sales"},

    {name: "Cadastro", key: "activity_control", group: "activity_control",
        description: "Permite cadastrar, visualizar e editar apenas as atividades do usuário."
    },
    {name: "Time", key: "activity_control_team", dependsOn: ["activity_control"], group: "activity_control",
        description: 'Em conjunto com "Lider de time" permite visualizar as atividades dos usuários com o mesmo "Time Gitlab".'
    },
    {name: "Geral", key: "activity_control_general", dependsOn: ["activity_control"], group: "activity_control",
        description: 'Permite visualizar as atividades de todos os usuários e da acesso a tela "Acompanhamentos".'
    },
    {name: "Organização de demandas", key: "activity_control_demands", group: "activity_control",
        description: 'Permite visualizar as demandas.'
    },

    {name: "Acesso completo", key: "cv_candidates", group: "curriculum_vitae"},
    {name: "Apenas visualizar candidatos", key: "cv_candidates_view_only", group: "curriculum_vitae"},

    // {name: "Licenças - Sentry", key: "licenses", group: "actions"},
    // {name: "Projetos (Cidades) - Inventário", dependsOn:["cities"], key: "inventory", group: "actions"},
    // {name: "Controle de requisitos", key: "requirements_control", group: "access"},

];
